import { ENDPOINTS, HOSTS } from "@/constants";
import {
  ADD_CPERAPPORT,
  ADD_CPERAPPORT_FAILURE,
  ADD_CPERAPPORT_SUCCESS,
  DELETE_CPERAPPORT,
  DELETE_CPERAPPORT_FAILURE,
  DELETE_CPERAPPORT_SUCCESS,
  LOAD_CPERAPPORT,
  LOAD_CPERAPPORT_FAILURE,
  LOAD_CPERAPPORT_SUCCESS,
  LOAD_CPERAPPORTS,
  LOAD_CPERAPPORTS_FAILURE,
  LOAD_CPERAPPORTS_SUCCESS,
  UPDATE_CPERAPPORT,
  UPDATE_CPERAPPORT_FAILURE,
  UPDATE_CPERAPPORT_SUCCESS,
} from "./mutations";
import type { ActionTree } from "vuex";
import type { RootState } from "@/types";
import { type AxiosResponse, httpClient } from "@/services/httpClient";
import type { CpeRapportListState } from "@/types/store";
import type { CpeRapport } from "@/types/cpe";

export const actions: ActionTree<CpeRapportListState, RootState> = {
  fetchCperapports({ commit }, params: any) {
    commit(LOAD_CPERAPPORTS);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTS}`, { params }).then(
      (response: AxiosResponse<CpeRapport[]>) => {
        commit(LOAD_CPERAPPORTS_SUCCESS, response);
      },
      (error) => {
        commit(LOAD_CPERAPPORTS_FAILURE, error.message);
      },
    );
  },
  addCperapport({ commit }, cperapport: any) {
    return new Promise((resolve, reject) => {
      commit(ADD_CPERAPPORT);
      httpClient
        .post(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTS}`, {
          ...cperapport,
        })
        .then(
          (response: AxiosResponse<any>) => {
            if (response) {
              commit(ADD_CPERAPPORT_SUCCESS, response.data);
              resolve(response.data);
            } else {
              commit(ADD_CPERAPPORT_FAILURE, "response undefind");
              reject("response undefind");
            }
          },
          (error) => {
            commit(ADD_CPERAPPORT_FAILURE, error.message);
            reject(error);
          },
        );
    });
  },
  updateCperapport({ commit }, cperapport: any) {
    commit(UPDATE_CPERAPPORT);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTS}/${cperapport.id}`, cperapport)
      .then(
        (response: AxiosResponse<any>) => {
          commit(UPDATE_CPERAPPORT_SUCCESS, response.data);
        },
        (error) => {
          commit(UPDATE_CPERAPPORT_FAILURE, error.message);
        },
      );
  },

  // LOAD_ONE_CPERAPPORT
  fetchCperapport({ commit }, id: any) {
    commit(LOAD_CPERAPPORT);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTS}/${id}`).then(
      (response: AxiosResponse<any>) => {
        commit(LOAD_CPERAPPORT_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_CPERAPPORT_FAILURE, error.message);
      },
    );
  },

  deleteRapport({ commit }, repportId: any) {
    commit(DELETE_CPERAPPORT);
    httpClient
      .delete(`${HOSTS.AWS}/${ENDPOINTS.CPERAPPORTS}/${repportId}`)
      .then(
        () => {
          commit(DELETE_CPERAPPORT_SUCCESS, repportId);
        },
        (error) => {
          commit(DELETE_CPERAPPORT_FAILURE, error.message);
        },
      );
  },
};
